export default function memberForms() {
	const forms = document.querySelectorAll("form[data-members-form]");

	forms.forEach((form) => {
		const input = form.querySelector("[data-members-email]");
		const button = form.querySelector('button[type="submit"]');
		if (!input || !button) return;

		const syncState = () => {
			const loading = form.classList.contains("loading");
			const invalid = form.classList.contains("error");

			button.disabled = loading;
			button.setAttribute("aria-busy", String(loading));
			input.setAttribute("aria-invalid", String(invalid));
		};

		const observer = new MutationObserver(syncState);
		observer.observe(form, { attributes: true, attributeFilter: ["class"] });
		syncState();
	});
}
